// import { useOrgStore } from '@/stores/org-store';
import { useOrgStore } from '@/stores/org-store';
import { apiRequest } from '../../utils/api-request';

interface DeleteCollectionResponse {
  data?: {
    status: 'success' | 'error';
    message: string;
    organization_id: string;
    collection: string;
    total_deleted: number;
    deleted_objects: string[];
  };
  detail?: string;
}

export const deleteCollection = async (
  id: string,
): Promise<DeleteCollectionResponse> => {
  const orgId = useOrgStore.getState().currentOrg?.orgid;

  if (!orgId) {
    throw new Error('Organization ID is required');
  }

  const response = await apiRequest<DeleteCollectionResponse>({
    url: `/collections/${orgId}/${id}`,
    method: 'DELETE',
    target: 'platform',
  });

  if (response?.detail) {
    return {
      detail: response.detail || 'Failed to delete data collection',
    };
  }

  return response as DeleteCollectionResponse;
};

export const hardDeleteCollection = async (
  id: string,
): Promise<DeleteCollectionResponse> => {
  const orgId = useOrgStore.getState().currentOrg?.orgid;

  if (!orgId) {
    throw new Error('Organization ID is required');
  }

  const response = await apiRequest<DeleteCollectionResponse>({
    url: `/collections/${orgId}/${id}/hard`,
    method: 'DELETE',
    target: 'platform',
  });

  if (response?.detail) {
    return {
      detail: response.detail || 'Failed to hard delete collection',
    };
  }

  return response as DeleteCollectionResponse;
};
